var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "group-table" }, [
    _c("thead", [
      _c(
        "tr",
        { staticClass: "rounded" },
        _vm._l(_vm.headers, function (header, i) {
          return _c(
            "th",
            {
              key: header.key,
              style: header.isBar ? "width: 60%;" : "",
              attrs: { title: header.title },
            },
            [
              i === 0
                ? _c(
                    "v-popover",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: { offset: "5" },
                    },
                    [
                      _c(
                        "a",
                        { attrs: { role: "button", title: "Column meanings" } },
                        [
                          _c("span", {
                            staticClass: "fa fa-lg fa-question-circle",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("template", { slot: "popover" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-condensed",
                            staticStyle: {
                              "table-layout": "auto",
                              "max-width": "calc(100vw - 75px)",
                              width: "500px",
                            },
                          },
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.definitions, function (row, i) {
                                return _c(
                                  "tr",
                                  { key: i },
                                  _vm._l(row, function (cell, j) {
                                    return _c("td", { key: j }, [
                                      _vm._v(_vm._s(cell)),
                                    ])
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              header.sortProp
                ? _c(
                    "a",
                    {
                      class: { sort: true, disabled: _vm.disabled },
                      attrs: {
                        role: "button",
                        title: `${header.title} ${_vm.$t(
                          "results.table.clickToSort"
                        )}`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeSort(header.sortProp)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(header.label) + "\n\t\t\t\t"
                      ),
                    ]
                  )
                : [_vm._v(_vm._s(header.label))],
            ],
            2
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm._l(_vm.data, function (row) {
          return [
            _c("GroupRow", {
              key: row.id,
              attrs: { data: row, columns: _vm.columns, maxima: _vm.maxima },
              nativeOn: {
                click: function ($event) {
                  return _vm.$set(_vm.open, row.id, !_vm.open[row.id])
                },
              },
            }),
            _vm._v(" "),
            _c("GroupRowDetails", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open[row.id],
                  expression: "open[row.id]",
                },
              ],
              key: `${row.id}-concordances`,
              attrs: {
                type: _vm.type,
                query: _vm.query,
                mainAnnotation: _vm.mainAnnotation,
                otherAnnotations: _vm.otherAnnotations,
                metadata: _vm.metadata,
                disabled: _vm.disabled,
                dir: _vm.dir,
                html: _vm.html,
                data: row,
                open: _vm.open[row.id],
              },
              on: {
                openFullConcordances: function ($event) {
                  return _vm.$emit(
                    "openFullConcordances",
                    row.id,
                    row.displayname
                  )
                },
                close: function ($event) {
                  return _vm.$set(_vm.open, row.id, false)
                },
              },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }